/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	init: (app, gsap, ScrollTrigger, Menu, Kira, CustomEase) => {
		/*
		|
		| Constants
		|-----------
		*/
        const
            html              = document.querySelector('html'),
            body              = document.querySelector('body'),
            $body             = $('body'),
            $pageLoader       = $('.page-loader'),
            scrollAreas       = document.querySelectorAll('.scroll-area'),
            $splitItems       = $body.find('[data-splittext]'),

            $menuWrapper      = $('#mobile-menu'),
            $menuButton       = $('#header .btn-menu'),
            $menuBars         = $menuButton.find('.item-burger > span'),
            $menuClose        = $menuWrapper.find('.item-close'),
            $menuStaggerItems = $menuWrapper.find('[data-stagger-item]'),

            $menuWrapper2      = $('.menu-secondary'),
            $menuButton2      = $('#header .btn-menu-secondary'),
            $menuBars2        = $menuButton2.find('.item-burger2 > span'),
            $menuClose2        = $menuWrapper2.find('.item-close'),
            $menuStaggerItems2 = $menuWrapper2.find('[data-stagger-item2]')
        ;


        /*
		|
		| Easings
		|----------
        */
        CustomEase.create("easeCustom", "M0,0 C0.4,0 0.2,1 1,1")
        CustomEase.create("easeSmooth", "M0,0 C0.19,1 0.22,1 1,1")
        CustomEase.create("easeCustomPower1", "M0,0 C0.165,0.84 0.44,1 1,1")
        CustomEase.create("easeExpo", "M0, 0 C1, 0 0, 1 1, 1")

        /*
		|
		| SplitText
		|------------
        */
        $.each($splitItems, function() {
            const $item = $(this);
            const type = $item.data('splittext') ? $item.data('splittext') : 'words, chars';
            const split = new SplitText($item, { type: type, linesClass: 'item-line', wordsClass: 'item-word', charsClass: 'item-char' });

            $item[0]['split'] = split;
        });

        $body.on('dom:ready', () => {
            $splitItems.addClass('split-ready')
        } )


		/*
        |
        | Scroll Areas
        |---------------
        */
		Array.prototype.forEach.call(scrollAreas, element => {
			Scrollbar.init(element);
		});


        /*
		|
		| Loader
		|---------
        */
        if (sessionStorage.getItem('loaded_once') === null) {
            sessionStorage.setItem('loaded_once', 'loaded_once');
        }

        if ($pageLoader.hasClass('active')){
            const loaderTl = gsap.timeline({ paused: true, /*onComplete: () => $pageLoader.remove()*/ });

            loaderTl.to($pageLoader.find('.item-loadbar-inner'), 1, { scaleX: 1, ease: 'Power0.easeNone' }, 'start')
            loaderTl.from($pageLoader.find('.loader-last-image'), .1, { autoAlpha: 0, ease: 'Power1.easeOut', delay: 1.8 })
            loaderTl.to($pageLoader.find('.loader-last-image'), 2, {
                width: '100vw',
                height: '100vh',
                ease: CustomEase.create("custom", "M0,0 C0,0 0.147,0.085 0.228,0.136 0.302,0.182 0.374,0.22 0.43,0.256 0.476,0.29 0.624,0.384 0.662,0.404 0.809,0.481 0.786,0.45 0.844,0.616 0.862,0.668 0.862,0.678 0.874,0.727 0.886,0.778 0.896,0.777 0.914,0.83 0.946,0.889 1,1 1,1 "),
            })
            loaderTl.to($pageLoader, .6, { autoAlpha: 0 })
            loaderTl.to($pageLoader.find('.item-content'), 0.8, { autoAlpha: 0, ease: 'Power1.easeOut' }, '-=0')
            loaderTl.call(() => { app.dispachEvent(body, 'dom:ready'); }, null)
            loaderTl.to($pageLoader, 0.8, { autoAlpha: 0, ease: 'Power1.easeOut' }, '-=0')

            $(window).on('load', function () {
                loaderTl.play();

            });
        } else {
            $(window).on('load', function(){
                app.dispachEvent(body, 'dom:ready');
            })

        }


        /*
		|
		| Menu
		|-------
        */
        const
            menuWrapper         = document.querySelector('#mobile-menu'),
            menuButton          = document.querySelector('#header .btn-menu'),

            menuWrapper2         = document.querySelector('.menu-secondary'),
            menuButton2          = document.querySelector('#header .btn-menu-secondary')
        ;

        const menu = new Menu(menuWrapper, menuButton, {
            reverseTimeScale: 2
        });
        menu.menuTimeline
            .to($menuBars.eq(1), 0.3, { autoAlpha: 0 }, 'start')
            .to($menuBars.eq(0), 0.5, { x: 0, y: 6, rotation: 45, ease: 'Power1.easeOut' }, 'start')
            .to($menuBars.eq(2), 0.5, { x: 0, y: -8, rotation: -45, ease: 'Power1.easeOut' }, 'start')
            .to($menuWrapper, 0.5, { autoAlpha: 1, ease: 'Power1.easeOut' }, 'start+=0.3')
            .staggerFrom($menuStaggerItems, 0.6, { autoAlpha: 0, x: 20, ease: 'Power1.easeOut' }, '0.1', '+=0')

        menu.init();

        const menu2 = new Menu(menuWrapper2, menuButton2, {
            reverseTimeScale: 2
        });
        menu2.menuTimeline
            .to($menuBars2.eq(1), 0.3, { autoAlpha: 0 }, 'start')
            .to($menuBars2.eq(0), 0.5, { x: 0, y: 6, rotation: 45, ease: 'Power1.easeOut' }, 'start')
            .to($menuBars2.eq(2), 0.5, { x: 0, y: -8, rotation: -45, ease: 'Power1.easeOut' }, 'start')
            .to($menuWrapper2, 0.5, { autoAlpha: 1, ease: 'Power1.easeOut' }, 'start+=0.3')
            .staggerFrom($menuStaggerItems2, 0.6, { autoAlpha: 0, x: 20, ease: 'Power1.easeOut' }, '0.1', '+=0')

        menu2.init();

        /*
        |
		| Kira
		|-----------
        */
        const kira = new Kira({
            loadEvent: [body, 'dom:ready'],
            scrollTrigger: {
                markers: false,
                //scroller: scrollContainerSelector,
            },
            tweenParams: {
                start: '-=0.6'
            }
        });

        /*
        | fadeInUp
        |-----------
        */
        kira.add('fadeInUp', (item, timeline, start) => {
            timeline.fromTo(item, 1.3, { y: 50 }, { y: 0, autoAlpha: 1, ease: 'easeSmooth' }, start)
        });

        /*
        | fadeInUp.parallax.sm
        |-----------------------
        */
        kira.add('fadeInUp.parallax', (item, timeline, start) => {
            timeline.fromTo(item, 0.8, { y: 100 }, { y: 0, autoAlpha: 1, ease: 'Sine.easeOut' }, start)
        });

        /*
        | splitline
        |------------
        */
        kira.add('splitline', (item, timeline, start) => {
            const delay = item.dataset.delay ? item.dataset.delay : 0.012;

            item.querySelectorAll('.item-line').forEach( line => {
                timeline.from($(line).find('> div, > em, > span'), 1.35, { y: '101%', ease: 'easeSmooth' }, start)
            } )
        });

        /*
        | splittext.long
        |-----------------
        */
        kira.add('splittext.long', (item, timeline, start) => {
            const delay = item.dataset.delay ? item.dataset.delay : 0.01;

            timeline.staggerFrom(item.split.chars, 0.8, {y: 5, opacity: 0, ease: 'Sine.ease0ut' }, delay, start)
        });

        /*
        | fadeInLeft.parallax.sm
        |-------------------------
        */
        kira.add('fadeInLeft.stagger.sm', ($item, timeline, start) => {
            timeline.staggerFromTo($item.querySelectorAll('[data-stagger-item]'), 0.6, { x: 20 }, { autoAlpha: 1, x: 0, ease: 'Power1.easeOut' }, '0.1', start)
        });

        /*
        | fadeInUp.parallax.sm
        |-------------------------
        */
        kira.add('fadeInUp.stagger.sm', ($item, timeline, start) => {
            timeline.staggerFromTo($item.querySelectorAll('[data-stagger-item]'), 1, { x: 20 }, { opacity: 1, x: 0, ease: 'Power1.easeOut' }, '0.05', start)
        });

        kira.init();
	}
}
